import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const DashboardBase = (
  <path
    fill='currentColor'
    d='M13 5c0-1.284.71-2 2-2h4c1.284 0 2 .71 2 2v4c0 1.284-.71 2-2 2h-4c-1.284 0-2-.71-2-2V5zM3 5c0-1.27.71-2 2-2h4c1.284 0 2 .728 2 2v14c0 1.27-.71 2-2 2H5c-1.284 0-2-.728-2-2V5zm10 10c0-1.284.71-2 2-2h4c1.284 0 2 .71 2 2v4c0 1.284-.71 2-2 2h-4c-1.284 0-2-.71-2-2v-4z'
  />
)

export const Dashboard = createIcon({
  displayName: 'Dashboard',
  viewBox: '0 0 24 24',
  path: DashboardBase,
})
